(function ($) {
  'use strict';
  $('#eform-submission-uk-coop-sweepstakes-form').on('submit', function (e) {
    var email = $('#edit-field-uk-email-0-value').val();
    var verifyEmail = $('#edit-field-uk-verify-email-0-value').val();

    if (!isEmail(email)) {
      e.preventDefault();
      $('#edit-field-uk-email-0-value').addClass('error');
      $('#email-error-message').addClass('active');
    }
    else if (!emailsMatch(email, verifyEmail)) {
      e.preventDefault();
      $('#edit-field-uk-verify-email-0-value').addClass('error');
      $('#email-error-message').addClass('active');
    }
    else {
      $('#edit-field-uk-email-0-value').removeClass('error');
      $('#edit-field-uk-verify-email-0-value').removeClass('error');
      $('#email-error-message').removeClass('active');
    }
  });

  $('#eform-submission-uk-coop-sweepstakes-form #edit-actions').on('click', function (e) {
    var requiredFields = document.querySelectorAll('.field--type-boolean .required');

    for (var i = 0; i < requiredFields.length; i++) {
      if (!requiredFields[i].checked) {
        requiredFields[i].classList.add('error');
        requiredFields[i].parentNode.classList.add('error');
      }
      else {
        requiredFields[i].classList.remove('error');
        requiredFields[i].parentNode.classList.remove('error');
      }
    }
  });

  function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }

  function emailsMatch(email, verifyEmail) {
    if (email === verifyEmail) {
      return true;
    }
    return false;
  }

})(jQuery);

